import request from '../http.js'


class QuestionEdit{
    insertQuestion(data) {
        return request.post('/question/insert',data)
    }
    updateQuestion(data){
        return request.post('/question/update',data)
    }
    deleteQuestion(data){
        return request.post('/question/delete',data)
    }
    fuzzyQueryQuestion(data){
        return request.post('/question/list/query',data)
    }
    insertTag(data){
        return request.post('/tag/insert',data)
    }
    updateTag(data){
        return request.post('/tag/update',data)
    }
    deleteTag(data){
        return request.post('/tag/delete',data)
    }
    queryAllTag(data){
        return request.post('/tag/get',data)
    }
    verifyQuestion(data){
        return request.post('/question/verify/update',data)
    }
    selectQuestionsVerifyRequired(data){
        return request.post('/question/verify/get',data)
    }
    selectQuestionsVerifyList(data){
        return request.post('/question/verify/list/get',data)
    }
    updateSimilarQuestion(data){
        return request.post('/question/similar/update',data)
    }
    deleteQuestionCompletely(data){
        return request.post('/question/delete/completely',data)
    }
}



export default new QuestionEdit()